import { Box, Grid, Stack } from '@mui/material';
import Slider1 from './images/pre.png';
import Slider2 from './images/bridge.png';
import Slider3 from './images/hello.png';
import Slider4 from './images/road.png';
import Slider5 from './images/1vs1.png';
import Slider6 from './images/banner.png';

const galleryImages = [
  {
    src: Slider1,
    alt: "LỚP PRE IELTS (2.0-3.5) TẠI HP ACADEMY DÀNH CHO NGƯỜI MỚI BẮT ĐẦU",
    link: 'https://hpacademy.vn/cap-lop-ielts/pre-ielts/',
    objectFit: 'cover'
  },
  {
    src: Slider2,
    alt: "Là khoá luyện thi dành cho các bạn dự định thi IELTS",
    link: 'https://hpacademy.vn/bridge-ielts/',
    objectFit: 'cover'
  },
  {
    src: Slider3,
    alt: "LỚP HELLO IELTS (4.5-5.5) TẠI HP ACADEMY DÀNH CHO NGƯỜI MỚI LÀM QUEN VỚI IELTS",
    link: 'https://hpacademy.vn/cap-lop-ielts/hello-ielts/',
    objectFit: 'cover'
  },
  {
    src: Slider4,
    alt: "ROAD TO IELTS là khoá luyện thi dành cho các bạn dự định thi IELTS.",
    link: 'https://hpacademy.vn/cap-lop-ielts/road-to-ielts/',
    objectFit: 'cover'
  },
  {
    src: Slider5,
    alt: "KHOÁ IELTS CẤP TỐC 1 KÈM 1 ",
    link: 'https://hpacademy.vn/cap-lop-ielts/ielts-1-kem-1/',
    objectFit: 'cover'
  },
  {
    src: Slider6,
    alt: "banner",
    link: 'https://www.facebook.com/hpacademy.vn',
    objectFit: 'fill'
  },
]

const PortalMainContent = () => {

  const handleClickImage = (link: string) => {
    window.open(link, '_blank');
  }

  return (
    <Stack width="100%" height="100vh" justifyContent={'center'}>
      <Grid
        container
        spacing={1.5}
        sx={{
          overflowY: "auto",
          padding: 4,
        }}
      >
        {galleryImages.map((image, index) => (
          <Grid
            item
            xs={6}
            md={4}
            key={index}
          >
            <Box
              sx={{
                position: "relative",
                width: "100%",
                aspectRatio: "5/3.25",
                overflow: "hidden",
                borderRadius: 2,
                boxShadow: 3,
                transition: "box-shadow 3s ease",
                "&:hover": {
                  boxShadow: 4,
                },
                "&:hover img": {
                  transform: "scale(1.01)",
                  cursor: "pointer",
                },
              }}
              onClick={() => {
                handleClickImage(image.link)
              }}
            >
              <img src={image.src} alt={image.alt} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            </Box>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};

export const PortalMain = () => {
  return (
    <div className='right-section'>
      <PortalMainContent />
    </div>
  );
};
